/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S2_P1Inputs */

const tr_mesafeli_s2_p1 = /** @type {(inputs: Mesafeli_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Sözleşme; Sağlayıcı'nın shoppanel.emonse.com alan adı altında sunduğu ShopPanel SaaS yazılım platformu hizmetlerinin Müşteri tarafından bedel karşılığında kullanılmasına ilişkin tarafların hak ve yükümlülüklerini düzenler.`)
};

const en_mesafeli_s2_p1 = /** @type {(inputs: Mesafeli_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Agreement governs the rights and obligations of the parties regarding the Customer's use, against payment, of the ShopPanel SaaS software platform services offered by the Provider under the domain shoppanel.emonse.com.`)
};

const de_mesafeli_s2_p1 = /** @type {(inputs: Mesafeli_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Vertrag regelt die Rechte und Pflichten der Parteien im Hinblick auf die entgeltliche Nutzung der ShopPanel SaaS-Softwareplattform durch den Kunden, die der Anbieter unter der Domain shoppanel.emonse.com bereitstellt.`)
};

const ru_mesafeli_s2_p1 = /** @type {(inputs: Mesafeli_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настоящий Договор регулирует права и обязанности сторон в отношении платного использования Клиентом услуг программной платформы ShopPanel SaaS, предоставляемых Поставщиком под доменом shoppanel.emonse.com.`)
};

/**
* | output |
* | --- |
* | "This Agreement governs the rights and obligations of the parties regarding the Customer's use, against payment, of the ShopPanel SaaS software platform servi..." |
*
* @param {Mesafeli_S2_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s2_p1 = /** @type {((inputs?: Mesafeli_S2_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S2_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s2_p1(inputs)
	if (locale === "de") return de_mesafeli_s2_p1(inputs)
	if (locale === "ru") return ru_mesafeli_s2_p1(inputs)
	return tr_mesafeli_s2_p1(inputs)
});